import React from "react";
import { Wrap } from "./styles";
import i18next from "i18next";
import { ButtonVariant } from "@zanichelli/albe-web-components";
import { ZButton } from "@zanichelli/albe-web-components/react";

type Props = {
  logged: boolean;
};
const RedirectButton: React.FC<Props> = ({ logged }) => {
  const btnLink = logged ? "/dashboard#/dizionari" : "";
  const btnTxt = logged
    ? i18next.t("newwotd.logged.button.text")
    : i18next.t("newwotd.notLogged.button.text");

  return (
    <Wrap>
      <ZButton
        variant={ButtonVariant.PRIMARY}
        onClick={() =>
          (window.location.href = process.env.REACT_APP_MYZ_URL + btnLink)
        }
        key={`redirectButton${logged}`}
      >
        {btnTxt}
      </ZButton>
    </Wrap>
  );
};

export default RedirectButton;
